import type { Cart, CartItemAccommodation } from '@feat/feat-cart/cart'

export function getHotelAdsCartItem(cart: Cart): CartItemAccommodation | null {
  const [item] = cart.items.all

  return cart.items.all.length === 1 && item?.__typename === 'CartItemAccommodation' ? item : null
}
